import React from 'react';
import { DateTime } from 'luxon';
import { QText, useCurrentUser } from '@qualio/ui-components';

type DueColumnProps = {
  dueAt: DateTime;
  closedAtDatetime?: DateTime;
  isInFinalStatuses?: boolean;
};

const DueColumn: React.FC<DueColumnProps> = ({ dueAt, closedAtDatetime, isInFinalStatuses }) => {
  const { formatDate } = useCurrentUser();

  // reference today for colour coding
  const today = DateTime.now().endOf('day').toMillis();

  const dueLimitTimestamp = closedAtDatetime && isInFinalStatuses ? closedAtDatetime.startOf('day').toMillis() : today;

  const textColor = dueAt.toMillis() < dueLimitTimestamp && !isInFinalStatuses ? 'red.500' : 'gray.800';
  return <QText color={textColor}>{formatDate(dueAt.startOf('day').toISO() ?? '')}</QText>;
};

export default DueColumn;
